import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { closeDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { ImageZoomListItemProps, ImageZoomListProps } from "models/utilTypes/fileUtilsTypes";
import { FileMetaData } from "models/propTypes/fileViewerPropTypes";
import { FileConstants } from "utils/constants";
//#endregion
//#region components
import FileViewer from "./fileViewer";
import { Grid } from "@mui/material";
import { Buffer } from "buffer";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const ImageZoom: React.FC<ImageZoomListProps> = (props) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const getImageMetaInfo = (images: ImageZoomListItemProps[]) => {
    return images.map(
      (image) =>
        ({
          imageId: image.id,
          contentType: image.fileMeta?.contentType ?? "",
          data: image.fileMeta?.content ?? "",
          pageNumber: 0,
        } as FileMetaData)
    );
  };

  const [isLoading, setLoading] = React.useState<boolean>(false);
  const [images, setImages] = React.useState<FileMetaData[]>(getImageMetaInfo(props.imageZoomListItems));
  const [currentPage, setCurrentPage] = React.useState<number>(props.currentPreviewIndex + 1);

  const [imageMeta, setImageMeta] = React.useState<FileMetaData | undefined>(undefined);

  React.useEffect(() => {
    loadImage(props.currentPreviewIndex);
  }, [props.currentPreviewIndex]);

  React.useEffect(() => {
    setImages(getImageMetaInfo(props.imageZoomListItems));
    loadImage(props.currentPreviewIndex);
  }, [props.imageZoomListItems]);

  const loadImage = (index: number): void => {
    setLoading(true);
    setCurrentPage(index + 1);

    const currentImage = images[index];
    if (currentImage.data) {
      setImageMeta(currentImage);
      setLoading(false);
    } else {
      props
        .getImageContent(currentImage.imageId)
        .then((res) => {
          if (res !== undefined) {
            const imgBase64 = Buffer.from(res).toString();
            const updatedImages = [...images];
            updatedImages[index].data = imgBase64;
            setImages(updatedImages);
            setImageMeta(updatedImages[index]);
          }
        })
        .catch((e) => {
          setImageMeta(undefined);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const onBackgroundClick = () => {
    dispatch(closeDialog());
  };

  return (
    <Grid
      id={FileConstants.FileViewerFullScreenId}
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      className={cssExports.fileViewerFullScreen}
      onClick={onBackgroundClick}
    >
      <FileViewer
        key="imageViewer-fullScreen"
        loadImage={loadImage}
        imageCount={props.imageZoomListItems.length}
        currentFile={imageMeta}
        currentPage={currentPage}
        isLoading={isLoading}
        fullScreen
      />
    </Grid>
  );
};

export default ImageZoom;
